module.exports = __webpack_public_path__ + "img/activity.6cd1144a.jpg";